export function getQuarterAndYear() {
  const now = new Date();
  const month = now.getMonth();
  const quarter = Math.floor(month / 3) + 1;
  const fullYear = now.getFullYear();
  const shortYear = fullYear % 100;
  return { quarter, fullYear, shortYear };
}

export function getDefaultSessionName() {
  const { quarter, fullYear } = getQuarterAndYear();
  return `Q${quarter} ${fullYear} PI Planning`;
}
